import { Track, StoreUserIdentifier } from "./actions/analyticsManager.actions";
import middleware from "./middlewares/analyticsManager.middleware";
import AnalyticsReducer from "./reducers/analyticsManager.reducer";
import * as trackers from "./trackers";
import * as onetrust from "./tracking/onetrust";
import AnalyticsManager from "./AnalyticsManager";

export {
  AnalyticsManager,
  middleware as analyticsMiddleware,
  AnalyticsReducer,
  onetrust,
  StoreUserIdentifier,
  Track,
  trackers,
};
